import { AnchorHTMLAttributes, ReactNode } from 'react';

interface ExternalLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: ReactNode;
}

/**
 * 站外链接统一用这个组件（新标签页打开 + noopener）。
 * 站内路由请继续用 react-router 的 <Link>。
 */
export default function ExternalLink({ href, children, ...props }: ExternalLinkProps) {
  const isMailto = href.startsWith('mailto:');
  return (
    <a
      href={href}
      {...(isMailto ? {} : { target: '_blank', rel: 'noopener noreferrer' })}
      {...props}
    >
      {children}
    </a>
  );
}
